import { render, staticRenderFns } from "./version.vue?vue&type=template&id=b5872d16&scoped=true&"
import script from "./version.vue?vue&type=script&lang=js&"
export * from "./version.vue?vue&type=script&lang=js&"
import style0 from "./version.vue?vue&type=style&index=0&id=b5872d16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5872d16",
  null
  
)

export default component.exports